import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; // @ts-check

import React, { useState, useEffect } from 'react';
import ReactDataGrid from 'react-data-grid';
import DataGridPagination from '../../../../data/Grid/GridView/Pagination';
import { CircularProgress, makeStyles } from '@material-ui/core';
import utils from '../../../../utils';
import './reactGridStyles.css';
import CellFormatter from './CsvCellFormater';

function getCsvContent(workspace, path) {
  var startIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var rowLimit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 50;
  return utils.request({
    url: '/backend/csvdata',
    query: {
      workspace: workspace,
      path: path,
      startIndex: startIndex,
      rowLimit: rowLimit
    }
  });
}

var useStyles = makeStyles({
  loadingIndicator: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginLeft: '-25px',
    marginTop: '-25px'
  }
}, {
  name: 'ECCsvPreview'
});

var CsvPreview = function CsvPreview(_ref) {
  var workspace = _ref.workspace,
      path = _ref.path,
      height = _ref.height;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      rows = _useState2[0],
      setRows = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      columns = _useState4[0],
      setColumns = _useState4[1];

  var _useState5 = useState(50),
      _useState6 = _slicedToArray(_useState5, 2),
      itemsPerPage = _useState6[0],
      setItemsPerPage = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      pageNumber = _useState8[0],
      setPageNumber = _useState8[1];

  var _useState9 = useState(0),
      _useState10 = _slicedToArray(_useState9, 2),
      rowsLength = _useState10[0],
      setRowsLength = _useState10[1];

  var classes = useStyles({});
  useEffect(function () {
    // initial csv request will always start from 0
    getCsvContent(workspace, path, 0, itemsPerPage).then(function (csvData) {
      var columnHeaders = csvData.Data[0].map(function (header, index) {
        return {
          key: index,
          name: header,
          resizable: true,
          formatter: CellFormatter
        };
      });
      setRows(csvData.Data.slice(1));
      setColumns(columnHeaders);
      setRowsLength(csvData.TotalCount);
    });
  }, [workspace, path]);

  var handlePageChange = function handlePageChange(event, newPage) {
    setPageNumber(newPage);
    refreshData(newPage, itemsPerPage);
  };

  var handleItemsPerPageChange = function handleItemsPerPageChange(event, newItemsPerPage) {
    setItemsPerPage(newItemsPerPage);
    refreshData(pageNumber, newItemsPerPage);
  };

  var refreshData = function refreshData(currentPageNumber, currentItemsPerPage) {
    getCsvContent(workspace, path, currentPageNumber * currentItemsPerPage, currentItemsPerPage).then(function (csvData) {
      setRows(csvData.Data.slice(1));
    });
  };

  if (!columns || !rows) return React.createElement(CircularProgress, {
    className: classes.loadingIndicator
  });
  return React.createElement("div", {
    className: "preview-css-grid"
  }, React.createElement(ReactDataGrid, {
    columns: columns,
    rowGetter: function rowGetter(i) {
      return rows[i];
    },
    rowsCount: itemsPerPage > rows.length ? rows.length : itemsPerPage,
    minHeight: height === 'auto' ? 35 * 15 + 40 : height,
    minColumnWidth: 120,
    headerRowHeight: 50
  }), React.createElement(DataGridPagination, {
    itemsPerPage: itemsPerPage,
    count: rowsLength,
    page: pageNumber,
    onChangeItemsPerPage: handleItemsPerPageChange,
    onChangePage: handlePageChange
  }));
};

CsvPreview.defaultProps = {
  width: '100%',
  height: 'auto'
};
export default CsvPreview;